import { AfterViewInit, Directive, ElementRef, Inject, NgModule, OnInit, Input } from '@angular/core';
import { WINDOW } from '@app/common/app-tokens';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements OnInit, AfterViewInit {

  @Input('appAutoFocus') timeout = 100;

  constructor(private el: ElementRef, @Inject(WINDOW) private window: Window) { }

  ngOnInit(): void {
    this.window.setTimeout(() => {
      this.el.nativeElement.focus();
    }, this.timeout);
  }

  ngAfterViewInit(): void {
    this.window.setTimeout(() => {
      this.el.nativeElement.focus();
    }, this.timeout);
  }
}
@NgModule({
  declarations: [AutoFocusDirective],
  exports: [AutoFocusDirective],
})
export class AutoFocusModule { }
